import { Environment } from "src/types/environment";

export const environment: Environment = {
  configuration: 'dev',
  appShortName: 'ActiveF',

  staticDataExpireDurationInMS: 3600000,
  sso: {
    redirectSignIn: ["https://dev.activef.cloud.incline-it.com"],
    redirectSignOut: ["https://dev.activef.cloud.incline-it.com"]
  }
};
